import moment from 'moment'

import {
  getDismissalsNotPastExpiry,
  loadExpiringDismissalsMap,
  saveExpiringDismissalsMap,
  type ExpiringDismissalsMap,
} from './expiringDismissalsMap'

const RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWNS_KEY = 'recentPurchaseSocialProofPopupCooldowns'
const RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWNS_VERSION = 1
const RECENT_PURCHASE_SOCIAL_PROOF_POPUP_OFFER_PAGE_COOLDOWN_ID = 'offerPageRecentPurchaseSocialProofPopupCooldown'
const RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWN_HOURS = 2

let cooldownsCache: ExpiringDismissalsMap | undefined

const readCooldowns = (): ExpiringDismissalsMap => {
  if (cooldownsCache !== undefined) {
    return cooldownsCache
  }

  try {
    cooldownsCache = loadExpiringDismissalsMap(
      RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWNS_KEY,
      RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWNS_VERSION,
    )
  } catch {
    cooldownsCache = {}
  }

  return cooldownsCache
}

const writeCooldowns = (cooldowns: ExpiringDismissalsMap) => {
  cooldownsCache = cooldowns

  try {
    saveExpiringDismissalsMap(
      RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWNS_KEY,
      RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWNS_VERSION,
      cooldowns,
    )
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted. Do not block offer-page rendering.
  }
}

export function isSocialProofPopupSuppressed(): boolean {
  const cooldowns = readCooldowns()
  const cooldown = cooldowns[RECENT_PURCHASE_SOCIAL_PROOF_POPUP_OFFER_PAGE_COOLDOWN_ID]

  if (!cooldown) {
    return false
  }

  const now = moment()
  const expiry = moment(cooldown.endDate)

  if (now.isAfter(expiry)) {
    const { [RECENT_PURCHASE_SOCIAL_PROOF_POPUP_OFFER_PAGE_COOLDOWN_ID]: _expiredCooldown, ...remainingCooldowns } =
      cooldowns
    writeCooldowns(remainingCooldowns)
    return false
  }

  return true
}

export function recordSocialProofPopupExposure() {
  const cooldowns = readCooldowns()
  const now = moment()

  writeCooldowns({
    ...getDismissalsNotPastExpiry(cooldowns, now),
    [RECENT_PURCHASE_SOCIAL_PROOF_POPUP_OFFER_PAGE_COOLDOWN_ID]: {
      endDate: now.clone().add(RECENT_PURCHASE_SOCIAL_PROOF_POPUP_COOLDOWN_HOURS, 'hours').toISOString(),
    },
  })
}
